
/* injects from baggage-loader */

'use strict';

import $ from 'jquery';

export default class DialogFeedbackController {
    constructor($log, $element, $timeout, $location, $rootScope, $scope) {
        'ngInject';
        this.$log = $log;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$location = $location;
        this.$rootScope = $rootScope;
        this.$scope = $scope;

        let locale = this.$location.url();

        this.aux = false;

        this.display = false;

        this.$rootScope.$on('displayMsg', (event, data) => { 
          if (data === true){
              this.display = true;
          }
        });

        if (locale === "/main/stage-sixth"){
          this.aux = true;
        }
    }

    ok(){
      this.modalInstance.close(true);
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }

    $onInit(){
      this.$timeout(this.setBackground.bind(this));
    }

    isOkay(){
      return this.resolve.type === 'ok';
    }

    isFail(){
      return this.resolve.type === 'fail';
    }

    setBackground(){
      return $(this.$element).closest('.modal-dialog').addClass(this.resolve.type);
    }

    //baixando a img
    baixa(){
      this.$rootScope.$emit('downloadImg', true);
      this.ok();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/feedback/feedback.controller.js